import Spinner from '../assets/icons/loader.svg?react'

const setClassName = ({ className, size }: { className?: string; size?: string }) => [className, size].filter(Boolean).join(' ')

const Loader = ({ className, size = 'medium', ...props }: { className?: string; size?: string; style?: any }) => (
  <Spinner className={setClassName({ className, size })} {...props} />
)

export default Loader
